import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "my-5" }
const _hoisted_2 = { style: {"text-align":"center"} }
const _hoisted_3 = {
  key: 0,
  style: {"display":"inline-block","border":"1px solid #ddd","padding":"10px","background":"white"}
}
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "text-center"
}
const _hoisted_7 = {
  key: 2,
  class: "text-red text-center"
}
const _hoisted_8 = { class: "my-5" }
const _hoisted_9 = { style: {"text-align":"center"} }
const _hoisted_10 = { class: "font-semibold text-center" }
const _hoisted_11 = { class: "mt-7" }
const _hoisted_12 = {
  key: 0,
  class: "text-red text-center mb-5"
}
const _hoisted_13 = { class: "flex" }

import { ref, onMounted } from 'vue';
    import axios from 'axios';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'RegistrationOtpForm',
  props: { accessToken: { type: String, required: true } },
  emits: ['otpRegistered'],
  setup(__props, { emit: __emit }) {

    const props = __props;
    const emit = __emit;

    const errorMessage = ref('');
    const loading = ref(false);
    const mfa_qr_code = ref(null);
    const mfa_security_key = ref(null);

    onMounted(() => {
        doGetMfaQrCodeAction();
    });

    async function doGetMfaQrCodeAction() {
        loading.value = true;
        errorMessage.value = '';
        try {
            const httpResponse = await axios.get(`/backoffice/auth/get_mfa_qr_code`, { headers: { Authorization: `Bearer ${props.accessToken}` } });
            mfa_qr_code.value = httpResponse.data.mfa_qr_code;
            mfa_security_key.value = httpResponse.data.mfa_security_key;
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    async function doEnableMfaAction() {
        loading.value = true;
        errorMessage.value = '';
        try {
            await axios.post(`/backoffice/auth/enable_mfa`, {}, { headers: { Authorization: `Bearer ${props.accessToken}` } });
            emit('otpRegistered');
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }


return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "font-semibold my-8 text-center" }, [
      _createTextVNode("Vérification OTP "),
      _createElementVNode("span", { class: "text-sm text-grey-500" })
    ], -1)),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-center" }, "Activer la double authentification en scannant le QR Code ci-dessous ou en saisissant le code de sécurité dans votre application Authenticator", -1)),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-center" }, "QR Code", -1)),
        _createElementVNode("div", _hoisted_2, [
          (mfa_qr_code.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (!mfa_qr_code.value.startsWith('PHN2Zw'))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: 'data:image/png;base64,' + mfa_qr_code.value,
                      height: "200px",
                      alt: "QR Code MFA"
                    }, null, 8, _hoisted_4))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: 'data:image/svg+xml;base64,' + mfa_qr_code.value,
                      height: "200px",
                      alt: "QR Code MFA"
                    }, null, 8, _hoisted_5))
              ]))
            : (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("p", null, "Génération du QR code...", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("p", null, "Erreur lors de la génération du QR code. Veuillez utiliser la clé de sécurité ci-dessous.", -1)
                ]))]))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-center" }, "Clé de sécurité", -1)),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h6", _hoisted_10, _toDisplayString(mfa_security_key.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (!!errorMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          (mfa_qr_code.value)
            ? (_openBlock(), _createBlock(_component_custom_button, {
                key: 0,
                id: "btn-submit",
                type: "submit",
                classesList: 'btn xl s20',
                loading: loading.value,
                onClick: doEnableMfaAction
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("img", {
                    src: "/icons/icon-menu-securite.svg",
                    class: "btn-icon",
                    alt: ""
                  }, null, -1),
                  _createElementVNode("span", null, "Activer la double authentification", -1)
                ]))]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})